import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ItemVisual } from '../components/ItemVisual';
import { audio } from '../core/audio';
import { useActivity } from './useActivity';

const CUP_COLORS = ['#FF7A7A', '#45B6FE', '#FFD166'];

export function RememberLocation({ activity, onComplete }) {
  const nCups = activity.cups || 2;
  const [phase, setPhase] = useState('show');
  const [where, setWhere] = useState(() => Math.floor(Math.random() * nCups));
  const [order, setOrder] = useState(() => Array.from({ length: nCups }, (_, i) => i));
  const { state, answer, showHint } = useActivity(activity, onComplete);

  useEffect(() => {
    let alive = true;
    (async () => {
      await audio.playVoice('mem_look');
      await new Promise((r) => setTimeout(r, 2200));
      if (!alive) return;
      setPhase('covered');
      await new Promise((r) => setTimeout(r, 1200));
      if (activity.swap && alive) {
        setOrder((o) => [o[1], o[0], ...o.slice(2)]);
        setWhere((w) => (w === 0 ? 1 : w === 1 ? 0 : w));
        await new Promise((r) => setTimeout(r, 1400));
      }
      if (!alive) return;
      setPhase('ask');
      audio.playVoice(activity.voice);
    })();
    return () => { alive = false; };
  }, [activity.id]); // eslint-disable-line

  return (
    <div className="flex-1 flex items-center justify-center gap-6 px-5" data-testid={`activity-${activity.id}`}>
      {order.map((cupId, slot) => (
        <motion.div key={cupId} layout transition={{ duration: 1.1, ease: 'easeInOut' }} className="flex flex-col items-center gap-3">
          {phase === 'show' && slot === where ? <ItemVisual item={activity.item} size={84} /> : phase === 'show' ? <div style={{ width: 84, height: 84 }} /> : null}
          <motion.button data-testid={`cup-${slot}`} whileTap={{ scale: 0.92 }}
            onClick={() => phase === 'ask' && answer(slot === where)}
            className="relative" style={{ minWidth: 108, minHeight: 108 }}>
            <motion.svg width="108" height="108" viewBox="0 0 100 100"
              animate={state === 'correct' && slot === where ? { y: [0, -30, -20] } : showHint && slot === where && phase === 'ask' ? { scale: [1, 1.06, 1] } : {}}
              transition={showHint && slot === where ? { repeat: Infinity, duration: 1.2 } : {}}>
              <path d="M20 15 L80 15 L72 85 Q50 95 28 85 Z" fill={CUP_COLORS[cupId % 3]} />
              <ellipse cx="50" cy="15" rx="30" ry="8" fill="#ffffff70" />
              <path d="M20 15 L80 15 L78 35 L22 35 Z" fill="#00000018" />
            </motion.svg>
            {state === 'correct' && slot === where && (
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2"><ItemVisual item={activity.item} size={64} /></div>
            )}
          </motion.button>
        </motion.div>
      ))}
    </div>
  );
}
